import React from 'react';

import { getCurrentInstance } from '@lumapps/instance/ducks/selectors';
import { useSelector } from '@lumapps/redux/react';
import { TranslateObject } from '@lumapps/translations';
import { currentLanguageSelector } from '@lumapps/translations/ducks/selectors';

import { getCurrentHeader } from '../../ducks/selectors';
import { ContentHeader as ContentHeaderUI, ContentHeaderProps as ContentHeaderUIProps } from './ContentHeader';

type ConnectedProps = Omit<
    ContentHeaderUIProps,
    | 'mediaList'
    | 'hasAutoplay'
    | 'hasRandom'
    | 'autoplayInterval'
    | 'displayType'
    | 'wrapperHeight'
    | 'mediaClass'
    | 'slideshowHeight'
    | 'defaultTitle'
    | 'defaultDescription'
    | 'currentLanguage'
>;

export const ContentHeader: React.FC<ConnectedProps> = (props) => {
    const header = useSelector(getCurrentHeader);
    const instance = useSelector(getCurrentInstance);
    const currentLanguage = useSelector(currentLanguageSelector);

    return (
        <ContentHeaderUI
            {...props}
            mediaList={header?.properties?.media || []}
            hasAutoplay={header?.properties?.autoplay ?? false}
            hasRandom={header?.properties?.random ?? false}
            autoplayInterval={header?.properties?.interval ?? 0}
            displayType={header?.properties?.style}
            wrapperHeight={header?.properties?.wrapperHeight}
            mediaClass={header?.properties?.mediaClass}
            slideshowHeight={header?.height ?? 0}
            defaultTitle={instance?.title as TranslateObject}
            defaultDescription={instance?.subtitle as TranslateObject}
            currentLanguage={currentLanguage}
        />
    );
};

ContentHeader.displayName = 'ContentHeaderConnected';
